import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const FormHeader = styled.h1`
  color: #989898;
  font-size: 1.3em;
  font-weight: 400;
  line-height: 1.2;
  margin: 0 0 1.2em;
  padding: 1.5em 1.5em 0;
  text-align: center;
`
export const FormInputWrapper = styled.div`
  background: #f5f5f5;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  position: relative;
  width: 100%;
`

export const FormIcon = styled(FontAwesomeIcon)`
  color: #989898;
  min-width: 50px;
  padding: 9px 0;
  position: absolute;
  text-align: center;
`

export const FormInput = styled.input`
  background-color: transparent;
  border: none;
  border-bottom: 2px solid #989898;

  box-sizing: border-box;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  outline: none;
  padding: 8px 48px;
  width: 100%;
  &:focus + .underline {
    width: 100%;
  }
`

export const FormInputUnderline = styled.span`
  position: absolute;
  bottom: 0;

  // to center the animation
  left: 50%;
  transform: translateX(-50%);

  height: 2px;
  width: 0;
  background-color: #005cd9;
  transition: 0.5s;
`

export const FormBackButton = styled.button`
  -webkit-background-position: center;
  -webkit-border-radius: 4px;
  -webkit-box-sizing: border-box;
  -webkit-transition: background 0.8s;
  background-color: transparent;
  background-position: center;
  border: 1px solid #dadce0;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  height: 36px;
  margin: 14px 0 6px;
  transition: background 0.8s;

  &:hover {
    background: #f1f3f4 radial-gradient(circle, transparent 1%, #f1f3f4 1%)
      center/15000%;
    cursor: pointer;
  }

  &:active {
    background-color: #d4d6d7;
    background-size: 100%;
    transition: background 0s;
  }
`

export const FormBackButtonIcon = styled(FontAwesomeIcon)`
  color: #989898;
  font-size: 1rem;
  margin: 6px;
`
export const FormBackButtonText = styled.p`
  color: #3c4043;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  margin: 6px;
  opacity: 1;
  text-transform: none;
`

export const FormUnOrderedList = styled.ul`
  max-height: 413px;
  overflow: auto;
  padding-left: 20px;
`

export const FormListItem = styled.li`
  border-bottom: 1px solid #e5e5e5;
  color: #005cd9;
  cursor: pointer;
  display: block;
  padding: 1.375em 2.2em 1.375em 5em;
  position: relative;
`

export const FormListItemImage = styled.img`
  height: 3.75em;
  width: 3.75em;
  border-radius: 12px;
  position: absolute;
  text-align: center;
  top: 6px;
  left: 0;
`

export const FormListItemGraphic = styled.div<{ color?: string }>`
  background: ${({ color }) => (!color ? '#005cd9' : color)};
  border-radius: 12px;
  height: 3.75em;
  left: 0;
  position: absolute;
  text-align: center;
  top: 6px;
  width: 3.75em;
`

export const FormListItemText = styled.div`
  -o-text-overflow: ellipsis;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FormListNoActivity = styled.p`
  color: #989898;
  font-family: Roboto, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 1.2;
  margin: 14px 24px;
  padding: 1.5em 1.5em;
  text-align: center;
`
